<span class="small text-secondary" *transloco="let t">
  ReZA App v0.10.1 &bull; 2022 &bull;
  <a routerLink="/imprint" class="text-secondary">{{ t('imprint') }}</a> &bull;
  <a routerLink="/privacy" class="text-secondary">{{ t('privacyPolicy') }}</a>
</span>
